export async function createCart(endpoint, storefrontAccessToken, discountCodes = []) {
	console.log("No GraphQL Cart ID found, creating a new one.");

	const query = `
	  mutation createCart($input: CartInput) {
		cartCreate(input: $input) {
		  cart {
			id
		  }
		}
	  }
	`;

	const variables = {
		input: {}
	};

	// If automatic discount codes are provided, include them in cart creation
	if (discountCodes.length > 0) {
		variables.input.discountCodes = discountCodes;
	}

	try {
	  const response = await fetch(endpoint, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  "X-Shopify-Storefront-Access-Token": storefrontAccessToken
		},
		body: JSON.stringify({
			query,
			variables: variables
		})
	  });

	  const result = await response.json();
	  const newCartId = result.data.cartCreate.cart.id;

	  localStorage.setItem('shopify_cart_id', newCartId);
	  return newCartId;
	} catch (error) {
	  console.error("Error creating cart:", error);
	  throw error;
	}
}